import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getAllAdminHeatersService } from 'shared/services';


export const ADMIN_HEATERS_BANK_KEY = ['adminHeatersBank'];


export const deriveElementsBank = (raw = []) => ({
  elementsOptions: [...raw].reverse(),
  partNumberSuggestions: [...new Set(raw.map((element) => element.partNumber))],
});

export const useSsrElementsBank = ({ enabled = true } = {}) => {
  const { data } = useQuery(ADMIN_HEATERS_BANK_KEY, getAllAdminHeatersService, {
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: false,
  });

  return useMemo(() => deriveElementsBank(data ?? []), [data]);
};
